import * as React from 'react';
import { Button, ButtonType } from '../../../../commonv3/components/atoms/buttons/Button';
import './confirmation.module.scss';
import { SheModal } from '../../../../commonv3/components/molecules/layout/SheModal';

type Props = {
    headerMessage: string;
    message: any;
    confirmationText: string;
    confirmationType?: ButtonType;
    rescheduleButtonText: string;
    loading?: boolean;
    open: boolean;
    onAbort: () => any;
    onReschedule: () => any;
    onConfirmation: () => any;
};

export class TrialLessonCancelConfirmation extends React.Component<Props> {
    render() {
        const {
            headerMessage,
            message,
            confirmationType = 'normal',
            confirmationText,
            open,
            onAbort,
            onConfirmation,
            loading = false,
            rescheduleButtonText,
            onReschedule,
        } = this.props;
        return (
            <SheModal open={open} onRequestClose={onAbort} id="trial-lesson-cancel-confirmation">
                <div styleName="confirmation">
                    <div styleName="header-message">{headerMessage}</div>
                    <div styleName="message">{message}</div>
                    <div styleName="trial-lesson-button-wrapper">
                        <Button
                            id="reschedule-button"
                            styleName="button"
                            type="primary"
                            size="m"
                            disabled={false}
                            onClick={onReschedule}
                        >
                            {rescheduleButtonText}
                        </Button>
                        <Button
                            styleName="button"
                            type={confirmationType}
                            size="m"
                            disabled={false}
                            loading={loading}
                            onClick={onConfirmation}
                            id="confirm-cancel-button"
                        >
                            {confirmationText}
                        </Button>
                    </div>
                </div>
            </SheModal>
        );
    }
}
